import { Component, OnInit } from '@angular/core';
import { DealerService } from '../../services/dealer.service';
import { User } from '../../models/user.model';
import { Role } from '../../models/role.model';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-dealer-management',
  templateUrl: './dealer-management.component.html'
})
export class DealerManagementComponent implements OnInit {

  public dealers: User[] = [];
  dealerToEdit: User;
  dealerToDelete: User;

  dealerSelected: User;

  errorForm = {
      email: '',
      username: '',
      firstname: '',
      lastname: '',
      company: ''
  };

  constructor(private dealerService: DealerService,
              public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
    this.dealerService.dealers.subscribe(dealers => {
      this.dealers = dealers;
      this.refreshList();
    });
  }

  refreshList() {
    console.log('BeforeSort:', this.dealers);
    this.dealers = this.dealers.sort((a, b) => {
      const compareCompany = (a.company && b.company) ? a.company.toUpperCase().localeCompare(b.company.toUpperCase()) : -1;
      const compareLastname = (a.lastname && b.lastname) ?  a.lastname.toUpperCase().localeCompare(b.lastname.toUpperCase()) : -1;
      const compareFirstname = (a.firstname && b.firstname) ? a.firstname.toUpperCase().localeCompare(b.firstname.toUpperCase()) : -1;
      return compareCompany || compareLastname || compareFirstname;
    });
    console.log('AfterSort:', this.dealers);
  }

  editDealer(dealer: User) {
    this.dealerToEdit = {...dealer};
  }

  createNewDealer() {
    this.dealerToEdit = new User(null, '', '', '', '', 'de', [Role.User], []);
  }

  removeDealer() {
    if (this.dealerToDelete) {
      this.dealerService.deleteDealer(this.dealerToDelete).then(result => {
        // console.log('result:', result);
        this.dealerToDelete = null;
      }, error => {
        console.log('error:', error);
        this.dealerToDelete = null;
      });
    }
  }

  saveDealer(dealer: User) {
    this.resetErrorForm();

    if (this.dealerToEdit
      && this.dealerToEdit.email
      && this.dealerToEdit.company
      && this.dealerToEdit.firstname
      && this.dealerToEdit.lastname
      && !this.checkIfMailExists(this.dealerToEdit.email, this.dealerToEdit)) {

      if (!this.dealerToEdit.login) {
        this.dealerToEdit.login = this.dealerToEdit.email;
      }

      this.dealerService.saveDealer(dealer).then(result => {
        // console.log('result:', result);
        this.dealerToEdit = null;
        this.resetErrorForm();
      }, error => {
        console.log('error:', error);
        this.resetErrorForm();
      });
    } else {

      if (!this.dealerToEdit.email) {
        this.errorForm.email = 'Bitte eine E-Mail-Adresse angeben';
      }
      if (!this.dealerToEdit.firstname) {
        this.errorForm.firstname = 'Bitte Vornamen eingeben';
      }
      if (!this.dealerToEdit.lastname) {
        this.errorForm.lastname = 'Bitte Nachnamen eingeben';
      }
      if (!this.dealerToEdit.company) {
        this.errorForm.company = 'Bitte eine Firma angeben';
      }
      if (!this.dealerToEdit.login) {
        this.errorForm.username = 'Bitte einen Benutzernamen angeben';
      }

      if (this.checkIfMailExists(this.dealerToEdit.email, this.dealerToEdit)) {
        this.errorForm.email = 'E-Mail-Adresse ist bereits vorhanden';
      }

    }
  }

  checkIfMailExists(email: string, dealer: User): boolean {
    let emailExists = false;
    this.dealers.forEach(
      (existing) => {
          if (existing.id !== dealer.id && existing.email === email) {
            emailExists = true;
          }
      }
    );
    return emailExists;
  }

  cancel() {
    this.dealerToEdit = null;
    this.resetErrorForm();
  }

  resetErrorForm() {
    this.errorForm = {
      email: '',
      username: '',
      firstname: '',
      lastname: '',
      company: ''
    };
  }

  resendActivation() {
    this.dealerService.resendActivationEmail('' + this.dealerSelected.id).then(
      result => {
        this.ngxSmartModalService.getModal('emailSuccessModal').open();
      }, error => {
        this.ngxSmartModalService.getModal('errorModal').open();
      });
  }
}
